
import VeeValidate from 'vee-validate';
import Messages from './messages';

var customRuleCount = 0;

// Configurando Locale
VeeValidate.Validator.addLocale(Messages.validation);

// Método para adicionar validação customizada para componente
VeeValidate.Validator.prototype.addComponentRule = function (vm, customRule) {

	if (!vm.$el) {
		return;
	}

	var fieldId = vm.$el.getAttribute('data-vv-id');
	
	if (!fieldId) {

		console.error('Ainda não implementado o tratamento para este caso.');
		return;

	} else {
		
		customRuleCount++;
		let field = this.fields.find({ id: fieldId });
		let ruleName = 'custom_rule_' + ((vm.$options && vm.$options.name) || '') + field.id + '_' + customRuleCount;
		this.extend(ruleName, customRule);
		field.rules = field.rules || {};
		field.rules[ruleName] = [];
		field.update({ rules: field.rules });
	}
};

VeeValidate.Validator.prototype.cleanErrors = function (names) {

	if (names) {
		names = (names instanceof Array) ? names : [ names ];
	}

	for (let field of this.fields.items) {
		
		if (!names || names.includes(field.name)) {

			this.errors.removeById(field.id);
			field.flags.invalid = false;
			field.flags.valid = true;
			field.updateClasses();
		}
	}
};

VeeValidate.Validator.extend('latitude', {
	getMessage: field => 'Latitude inválida.',
	validate: function (value) {
		
		let regex = /^(?:-|-?(?:\d|[1-8]\d?|90?)(?:\.[0-9]{0,6})?)$/;

		return regex.test(value);
	}
});

VeeValidate.Validator.extend('longitude', {
	getMessage: field => 'Longitude inválida.',
	validate: function (value) {
		
		let regex = /^(?:-|-?(?:\d|[1-9]\d?|1(?:[0-7]\d?)?|1(?:80?)?)(?:\.[0-9]{0,6})?)$/;

		return regex.test(value);
	}
});

VeeValidate.Validator.extend('numeroInteiro', {
	getMessage: field => 'Só é permitido inserir números.',
	validate: function (value) {
		
		let regex = /^(-?[1-9]+\d*)$|^0$/;

		return regex.test(value);
	}
});



// WEBPACK FOOTER //
// ./src/validations.js